import styles from './styles/ReviewReport.module.scss';
import { Button, Space } from 'antd';
import { inject, observer } from 'mobx-react';
import withRouter from '@/components/withRouter';
import MyIcon from '@/components/MyIcon';
import { Display } from '@/components/Display/Display';
import CardListOverThree from './components/ReviewReport/CardListOverThree';
import CardListOverOne from './components/ReviewReport/CardListOverOne';
import CardListEqualOne from './components/ReviewReport/CardListEqualOne';
import { useEffect, useRef, useState } from 'react';
import { pageProgressMap } from '@/utils/contants/caseSimulation';
import { getToPathByStage } from './utils';
import ResultLoading from './components/Loading/ResultLoading';
import { handleDownloadReport } from '@/api/grt/simulation';
import GrtLoading from '@/components/Web/GrtLoading';
import { getSearchStr } from '@/utils/Page';
const searchStr = getSearchStr();
const ReviewReport = (props) => {
    let timerRef = useRef(null);
    let { navigate, params } = props;
    let { agentId, caseId, sceneId } = params;
    const [pageLoading, setPageLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const { simulation } = props.store;

    let { reviewReport = {}, reportCards = [], setHeaderIcon, getApiProgress, pageProgress, getContent, reStart } = simulation;

    useEffect(() => {
        setHeaderIcon({
            role: false,
            back: false,
            reStart: false
        });
    }, []);
    //清除定时器
    const clearTimer = () => {
        if (timerRef.current) {
            clearInterval(timerRef.current);
            timerRef.current = null;
        }
    };
    const getProgress = async () => {
        let progress = await getApiProgress(caseId);
        if (progress === pageProgressMap['report_ready']) {
            await getContent();
            setTimeout(() => {
                setLoading(false);
            }, 1000);
            clearTimer();
        }
    };
    const startTimer = () => {
        console.log('定时器开始');
        if (timerRef.current) {
            return;
        }
        timerRef.current = setInterval(() => {
            getProgress();
        }, 3000);
    };
    //第一次进入页面的时候获取进度更改页面loading状态
    const getProgressInFirst = async () => {
        setPageLoading(true);
        let progress = await getApiProgress(caseId);
        if (progress === pageProgressMap['report_generating']) {
            setLoading(true);
            setPageLoading(false);
            startTimer();
        } else if (progress === pageProgressMap['report_ready']) {
            await getContent();
            setPageLoading(false);
        } else {
            let path = getToPathByStage(pageProgress);
            navigate(`/web/o/${agentId}/simulation/${caseId}/${sceneId}/${path}${searchStr}`, { replace: true });
        }
    };
    useEffect(() => {
        getProgressInFirst();
        return () => {
            clearTimer();
        };
    }, []);

    const downloadReport = () => {
        handleDownloadReport(caseId);
    };

    //重新开始弹窗
    const showRestartModal = () => {
        simulation.setGuideModalShow({
            role: false,
            back: false,
            restart: true
        });
    };
    return (
        <div className={styles.container} data-loading={loading || pageLoading}>
            <Display show={pageLoading}>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%' }}>
                    <GrtLoading />
                </div>
            </Display>
            <Display show={!pageLoading}>
                <>
                    <Display show={loading}>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', width: '100%' }}>
                            <ResultLoading text="正在生成复盘报告，请稍后"></ResultLoading>
                        </div>
                    </Display>
                    <Display show={!loading}>
                        <>
                            {/* 标题部分 */}
                            <div className={styles.header}>
                                <h1 className={styles.title}>【复盘报告】</h1>
                                <div className={styles.actions}>
                                    <Space>
                                        <Button
                                            style={{ gap: '2px' }}
                                            icon={<MyIcon style={{ verticalAlign: 'middle' }} type="icon-xiazai"></MyIcon>}
                                            type="text"
                                            onClick={downloadReport}
                                        >
                                            下载报告
                                        </Button>
                                        <Button
                                            style={{ gap: '2px' }}
                                            icon={<MyIcon type="icon-zhongxinjiazai"></MyIcon>}
                                            onClick={showRestartModal}
                                            type="primary"
                                        >
                                            重新开始
                                        </Button>
                                    </Space>
                                </div>
                            </div>

                            {/* 完整事件回顾 */}
                            <div className={styles.eventReviewSection}>
                                <div className={styles.sectionTitle}>
                                    完整事件<span style={{ color: '#FA8C16' }}>回顾</span>
                                </div>
                                <Display show={reportCards.length > 3}>
                                    <CardListOverThree reportCards={reportCards}></CardListOverThree>
                                </Display>
                                <Display show={reportCards.length > 1 && reportCards.length < 4}>
                                    <CardListOverOne reportCards={reportCards}></CardListOverOne>
                                </Display>
                                <Display show={reportCards.length === 1}>
                                    <CardListEqualOne reportCards={reportCards}></CardListEqualOne>
                                </Display>
                            </div>

                            {/* 核心问题诊断 */}
                            <h2 className={styles.sectionTitle}>
                                核心问题<span style={{ color: '#9254DE' }}>诊断</span>
                            </h2>
                            <div className={styles.diagnosisSection}>
                                <ul className={styles.diagnosisList}>
                                    {reviewReport &&
                                        reviewReport?.diagnosis?.map((ele, index) => {
                                            return (
                                                <li className={styles.diagnosisItem} key={index}>
                                                    {ele}
                                                </li>
                                            );
                                        })}
                                </ul>
                            </div>
                            {/* 优化方向建议 */}
                            <h2 className={styles.sectionTitle}>
                                优化方向
                                <span style={{ color: '#13A8A8' }}>建议</span>
                            </h2>
                            <div className={styles.suggestionSection}>
                                <ul className={styles.suggestionList}>
                                    {reviewReport &&
                                        reviewReport?.suggestions?.map((ele, index) => {
                                            return (
                                                <li className={styles.suggestionItem} key={index}>
                                                    {ele}
                                                </li>
                                            );
                                        })}
                                </ul>
                            </div>
                        </>
                    </Display>
                </>
            </Display>
        </div>
    );
};
export default withRouter(inject('store')(observer(ReviewReport)));
